import Close from "@assets/svg/close.svg";
import NoDataIcon from "@assets/svg/no-data.svg";
import InfoLightIcon from "@assets/svg/student/info_light.svg";
import ChartArrowIcon from "@assets/svg/student/wallet/chart-arrow.svg";
import DepositIcon from "@assets/svg/student/wallet/deposit.svg";
import WithdrawIcon from "@assets/svg/student/wallet/withdraw.svg";
import { Spinner } from "@components/index";
import Modal from "@components/ui/Modal";
import gate from "@gate/index";
import { TransactionsEachUserWithCoin } from "@interfaces/transaction";
import { commafy, getTextAndColorByNumber } from "@lib/index";
import React, { FC, useEffect, useState } from "react";
import { useQuery } from "react-query";

import {
  convertMiladiToJalali,
  convertNumberToPriceFormat,
} from "../../../../src/utils";

type Props = {
  availableBalance: number;
};
// const preventLoadingLoop = false;
const params: TransactionsEachUserWithCoin = {
  search: "",
  pageSize: 30,
  pageNumber: 1,
  sortBy: "",
  isSortAsc: true,
  fieldSearchs: [
    {
      fieldName: "",
      type: "",
      text: "",
      min: 0,
      max: 0,
      opration: "",
      options: [],
    },
  ],
  coin: "DADCOIN",
};
const WalletDadcoin: FC<Props> = ({ availableBalance }) => {
  const [showModal, setShowModal] = useState(false);
  const {
    data: dataTransaction,
    isLoading: isLoadingTransaction,
    refetch,
  } = useQuery(
    `wallet-transaction-dadcoin`,
    () =>
      gate.getTransactionsEachUserWithCoin({
        ...params,
        sortBy: "Date",
        isSortAsc: false,
        pageSize: params.pageSize,
        pageNumber: params.pageNumber,
      }),
    {
      select: ({ data }: any) => data,
    }
  );
  const getValueByKey = (item: any, type: string) => {
    return item.items.find((values: any) => values.fieldName === type);
  };
  // useEffect(() => {
  //   window.addEventListener("scroll", handleScroll);
  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, []);
  // const handleScroll = () => {
  //   if (
  //     window.scrollY >
  //       window.document.body.offsetHeight -
  //         window.document.body.offsetHeight / 1.5 &&
  //     !preventLoadingLoop
  //   ) {
  //     preventLoadingLoop = true;
  //     params.pageNumber = params.pageNumber + 1;
  //     console.log('asd0asda-sd-a-d-')
  //     refetch()
  //   }
  // };
  return (
    <>
      <div className="mx-[10px] mb-[10px] mt-[5px] grid grid-cols-1 lg:grid-cols-3">
        <div className="lg:col-span-1">
          <h2 className="text-xs font-bold text-[#4A4A4A] md:text-sm lg:text-lg">
            لیست تراکنش‌های کیف پول دادکوین شما
          </h2>
        </div>
        <div className="lg:col-span-2">
          <div className="mt-3 ml-0 mr-0 w-fit text-xs font-bold text-[#4A4A4A] md:text-sm lg:mr-auto lg:mt-auto lg:text-lg">
            <ChartArrowIcon className="inline-block w-[20px] text-[#4E4E56] md:w-auto" />{" "}
            موجودی کیف پول دادکوین:{" "}
            <span className="font-bold text-[#183BA7]">
              {convertNumberToPriceFormat(availableBalance)}
            </span>{" "}
            دادکوین
            <div>
              <button
                className="mt-2 mr-8 hidden text-right text-xs text-[#2747AB] md:text-sm lg:inline-block"
                onClick={() => setShowModal(true)}
              >
                <InfoLightIcon className="ml-1 inline-block w-5 md:w-auto" />
                راهنمای استفاده از دادکوین
              </button>
            </div>
          </div>
          {/*<div className="grid grid-cols-3 lg:ml-0 lg:mr-auto lg:w-fit items-center">*/}
          {/*  <div className="col-span-full lg:col-span-2 text-xs md:text-base mt-3 lg:mt-0">*/}
          {/*    <ChartArrowIcon className="inline-block text-[#4E4E56] w-[20px] md:w-auto"/> موجودی کیف پول دادکوین: <span className="text-[#183BA7]">500.000</span> دادکوین*/}
          {/*  </div>*/}
          {/*  <div className="col-span-1 text-left">*/}
          {/*    <Button*/}
          {/*      // isLoading={isLoading}*/}
          {/*      className="absolute -top-6 md:-top-7 left-0 lg:relative lg:top-0 w-max-content rounded border-2 border-[#1D3FA8] bg-[#1D3FA8] h-[32px] lg:h-[40px] py-0 px-2 text-white transition-all hover:ring-2 text-xs lg:text-base"*/}
          {/*    >*/}
          {/*      درخواست برداشت*/}
          {/*    </Button>*/}
          {/*  </div>*/}

          {/*</div>*/}
        </div>
      </div>
      <table className="responsive-table">
        <thead>
          <tr>
            <td scope="col" className="w-[80px]" />
            <th scope="col">شماره ارجاع</th>
            <th scope="col">شرح تراکنش</th>
            <th scope="col">
              مقدار <span className="font-medium">(دادکوین)</span>
            </th>
            <th scope="col">تاریخ</th>
            <th scope="col" className="w-[120px]">
              نوع تراکنش
            </th>
          </tr>
        </thead>
        <tbody>
          {!isLoadingTransaction ? (
            dataTransaction?.rows.length ? (
              dataTransaction.rows.map((item: any) => {
                return (
                  <tr>
                    <td>
                      {getValueByKey(item, "IsIncrease")?.value === "برداشت" ? (
                        <WithdrawIcon />
                      ) : (
                        <DepositIcon />
                      )}
                    </td>
                    <td data-label="شماره ارجاع:" className="relative">
                      <span
                        className={`absolute left-0 top-[6px] inline-block h-min rounded-full bg-[#DAF4EB] px-7 py-1 text-[#34C38F] md:hidden ${
                          getTextAndColorByNumber(
                            getValueByKey(item, "TransactionType")?.typeEnum
                          )?.class
                        }`}
                      >
                        {
                          getTextAndColorByNumber(
                            getValueByKey(item, "TransactionType")?.typeEnum
                          )?.text
                        }
                      </span>
                      {item?.id}
                    </td>
                    <td data-label="شرح تراکنش:">
                      {getValueByKey(item, "PayDescription").value}
                    </td>
                    <td data-label="مبلغ(تومان):">
                      {commafy(getValueByKey(item, "NormalizePrice").value)}
                    </td>
                    <td data-label="تاریخ:">
                      {convertMiladiToJalali(
                        getValueByKey(item, "Date")?.value
                      )}
                    </td>
                    <td
                      data-label="نوع تراکنش:"
                      className="!hidden md:!table-cell"
                    >
                      <span
                        className={`h-min rounded-full px-7 py-1 ${
                          getTextAndColorByNumber(
                            getValueByKey(item, "IsIncrease")?.value
                          )?.class
                        }`}
                      >
                        {
                          getTextAndColorByNumber(
                            getValueByKey(item, "IsIncrease")?.value
                          )?.text
                        }
                      </span>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={6} className="!text-center">
                  <NoDataIcon className="-mt-5 inline-block h-[200px] w-full md:h-[40vh]" />
                  <p className="-mt-5 text-base text-[#4E4E56] md:-mt-8">
                    شما هنوز تراکنشی ثبت نکرده اید!
                  </p>
                </td>
              </tr>
            )
          ) : (
            <tr>
              <td colSpan={6}>
                <div className="py-20 text-center">
                  <Spinner className="mx-auto h-10 w-10 animate-opacity animate-fade-in-down" />
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <Modal
        visible={showModal}
        className="left-0 right-0 mx-auto w-full max-w-[60rem] justify-start px-4 lg:px-0"
        onClose={() => setShowModal(false)}
      >
        <div className="relative rounded-2xl bg-white">
          <span
            onClick={() => setShowModal(false)}
            className="absolute top-3 left-3 cursor-pointer p-3"
          >
            <Close />
          </span>
          <div className="p-5">
            <h2 className="text-xs font-bold text-[#4A4A4A] md:text-sm lg:text-lg">
              راهنمای استفاده از دادکوین
            </h2>
          </div>
          <hr />
          <div className="p-5">
            <div className="max-h-[50vh] overflow-auto pl-4 text-justify text-sm md:text-xl">
              <div className="text-[10px] text-[#4E4E56] md:text-sm lg:text-base">
                <p>
                  در راستای استفاده از کیف پول تومانی و کیف پول دادکوینی رعایت و
                  توجه به نکات زیر ضروری است:
                </p>
                <p>مقدمه:</p>
                <p>
                  ایجاد کیف پول در سایت دادبانان، جهت تقدیر و تکریم دانش‌پذیران
                  وفادار دادبانان و به پاس همراهی آن‌ها ایجاد شده است و کاربر
                  می‌تواند تحت مقررات دادبانان، با کیف پول تومانی خود از سایت
                  دادبانان خرید نموده یا وجه آن را برداشت نماید ولی محتوای کیف
                  پول دادکوین، حاوی نوعی امتیاز و هدیه است و کاربر می‌تواند صرفا
                  با آن از سایت دادبانان خرید نماید ولی قابل برداشت نیست؛
                </p>
                <p>
                  وجوه داخل کیف پول صرفا به کاربر اختصاص داشته و قائم به شخص
                  اوست و به هیچ عنوان قابل انتقال یا توقیف نمی‌باشد.
                </p>
                <p>
                  ۱. این توافقنامه از یک طرف از جانب آموزشگاه دادبانان دانا به
                  نشانی وبسایت www.dadbanan.com و از طرف دیگر از جانب کاربر، از
                  لحظه تایید آن قابل استناد است. مفاد موافقنامه از سوی دادبانان
                  ارائه می‌شود و پس از موافقت کاربر و تایید آن (با ثبت نام به
                  عنوان کاربر) به مورد اجرا گذاشته می‌شود. بنابراین با هر بار
                  استفاده از خدمات سایت، کاربر مسئولیت مطالعه و آگاهی کلیه
                  قوانین و مقررات را بر عهده دارد. در صورت عدم توافق با این
                  شرایط شما قادر به استفاده از خدمات سایت نخواهید بود.
                </p>
                <p>
                  شرایط و قوانین ذکرشده در این بخش به‌ منظور خدمات‌رسانی بهتر به
                  کاربران گرامی دادبانان در نظر گرفته‌ شده است. برای اطلاع از
                  شیوه ارائه خدمات، موضوعات عنوان‌شده را با دقت مطالعه کنید.
                </p>
                <p>
                  در صورت هرگونه ابهام در خصوص مفاد این توافقنامه کاربران می
                  توانند با کارشناسان دادبانان ارتباط برقرار و اطلاعات مورد نیاز
                  را دریافت نمایند.
                </p>
                <p>
                  ۲. با وارد نمودن شماره موبایل، یک کد تایید به آن ارسال خواهد
                  شد، با وارد نمودن کد در سایت دادبانان موبایل شما مورد تایید
                  قرار خواهد گرفت. در وارد نمودن شماره موبایل دقت نمایید زیرا
                  یکی از راه‌های ارتباطی ما با شما در هنگام بروز مشکل همین خواهد
                  بود. شماره تلفن همراه می‌بایست به نام خود کاربر باشد.
                </p>
                <p>
                  ۳. تنها اشخاصی که بیش از ۱۸ سال سن و واجد اهلیت قانونی باشند
                  می‌توانند اقدام به ساختن حساب کاربری در سایت دادبانان نمایند.
                </p>
                <p>
                  ۴. کاربر موظف است تا درباره دسترسی‌ نداشتن دیگران به حساب
                  کاربری و حساب‌های بانکی و کیف ‌پول خود و سوءاستفاده از آن‌ها،
                  دقت لازم را داشته باشد و مسئولیت تراکنش‌ها که از طریق حساب
                  کاربری کاربر صورت می‌گیرد منحصرا به عهده کاربر است.
                </p>
                <p>
                  ۵. چنانچه تراکنش مالی مشکوک از طریق کیف پول کاربر صورت گرفته
                  باشد، دسترسی کاربر به حساب کاربری قابل قطع بوده و کاربر مجدداً
                  باید احراز هویت نماید.
                </p>
                <p>
                  ۶. دادبانان میتواند برای استفاده از کیف پول و موجودی آن مدت
                  زمان خاصی را لحاظ کند. در صورتی که به هر دلیلی کسب و کار
                  آموزشگاه متوقف شود یا سایر موارد مشابه، به دلیل منتفی شدن
                  موضوع خرید از سایت، کیف پول دادکوینی نیز منتفی می‌گردد. در
                  صورت نیاز به استرداد وجه کیف پول تومانی، واریز به حسابی که
                  کاربر سابقه تراکنش با آن دارد رافع مسئولیت دادبانان است.
                </p>
                <p>
                  ۷. اگر دادبانان تحت هر عنوان اشتباهاً یا سهواً، وجوهی را به
                  حساب کاربر واریز نماید، هر زمان مجاز و مختار است راساً و بدون
                  انجام هیچ گونه تشریفات اداری و قضائی و دریافت اجازه کتبی از
                  کاربر (صاحب حساب) در رفع اشتباه یا حذف یا برداشت از کیف پول وی
                  اقدام نماید.
                </p>
                <p>
                  ۸. کلیه اختلافات احتمالی، منحصرا در صلاحیت مراجع قانونی شهر
                  تهران است.
                </p>
                <p>
                  ۹. ماهیت وجوهی که از طرف دادبانان به حساب کاربر واریز می‌شود
                  ماهیتا نوعی امتیاز و هدیه مجازی است و حکم پول یا ارز یا مشابه
                  آن ندارد.
                </p>
                <p>
                  ۱۰. استفاده از خدمات سایت (ثبت نام ـ خرید ـ برداشت و...) به
                  این معنی است که کاربر قوانین را کاملاً خوانده و قبول کرده و در
                  غیر اینصورت، حق استفاده از امکانات سایت را ندارد.
                </p>
                <p>از اینکه دادبانان را انتخاب نموده اید از شما سپاسگزاریم</p>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default WalletDadcoin;
